import { useTheme } from '@material-ui/core/styles';
import { lightColors, darkColors } from './colors';

/**
 * Hook to get theme-aware colors based on current Material-UI theme type
 * This provides easy access to the color palette that adapts to light/dark mode
 */
export const useThemeColors = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.type === 'dark';

  return isDarkMode ? darkColors : lightColors;
};

/**
 * Get colors for a specific theme mode
 * Useful for programmatic color selection
 */
export const getColorsForTheme = (isDark: boolean) => {
  return isDark ? darkColors : lightColors;
};

export default useThemeColors;
